import { useState } from "react";
import { Loader2 } from "lucide-react";
import { endpoints } from "@/lib/api";
import { useCached } from "@/lib/fbCache";

const TABS = [["39", "Premier League"], ["140", "La Liga"], ["135", "Serie A"], ["78", "Bundesliga"], ["61", "Ligue 1"], ["top5", "Top 5 combined"],
  ["2", "Champions League"], ["3", "Europa League"], ["848", "Conference League"]];

export const TopScorers = () => {
  const [lg, setLg] = useState("39");
  const q = useCached(`topscorers:${lg}`, () => endpoints.topScorers(lg), 30 * 60e3);
  const d = q.data;
  const rows = d?.scorers || [];
  const extra = rows.some((r) => r.assists != null);
  return (
    <div data-testid="fb-sec-scorers-panel">
      <div className="flex gap-2 overflow-x-auto pb-2 mb-4">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setLg(k)} data-testid={`scorers-tab-${k}`} aria-pressed={lg === k}
            className={`h-9 px-4 rounded-full text-sm font-bold whitespace-nowrap border transition-colors ${lg === k ? "bg-white text-black border-white" : "bg-black text-white border-white/25 hover:border-white"}`}>{l}</button>))}
      </div>
      {!d && q.loading ? <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-[#E11D2A]" /></div>
        : !rows.length ? <p className="text-slate-300 text-center py-10 rounded-xl border border-dashed border-white/20" data-testid="scorers-empty">
            {d && !d.configured ? "Top scorers will appear here once the football data service is connected." : lg === "78" ? "Bundesliga scorers will appear once the football data subscription is active." : "No scorer data yet for this competition."}</p>
        : (
        <div className="rounded-xl border border-white/15 overflow-hidden bg-black">
          <table className="w-full text-sm" data-testid="scorers-table">
            <thead className="text-[11px] uppercase tracking-wider text-slate-300 bg-white/5">
              <tr><th className="p-3 text-left w-10">#</th><th className="p-3 text-left">Player</th><th className="p-3 text-left hidden sm:table-cell">Club</th>
                <th className="p-3 text-right">Goals</th>{extra && <><th className="p-3 text-right hidden sm:table-cell">Assists</th><th className="p-3 text-right hidden md:table-cell">Apps</th></>}</tr>
            </thead>
            <tbody>{rows.map((r, i) => (
              <tr key={`${r.id}-${i}`} className="border-t border-white/10" data-testid={`scorer-row-${i}`}>
                <td className={`p-3 font-extrabold ${i < 3 ? "text-[#E11D2A]" : "text-slate-300"}`}>{i + 1}</td>
                <td className="p-3"><div className="flex items-center gap-3 min-w-0">
                  {r.photo && <img src={r.photo} alt="" loading="lazy" className="w-8 h-8 rounded-full object-cover bg-white/10 shrink-0" />}
                  <div className="min-w-0"><div className="text-white font-semibold truncate">{r.name}</div>
                    <div className="text-xs text-slate-400 truncate sm:hidden">{r.team}</div>
                    {r.league && <div className="text-[11px] text-slate-500 truncate">{r.league}</div>}</div></div></td>
                <td className="p-3 hidden sm:table-cell"><div className="flex items-center gap-2 text-slate-200">{r.teamLogo && <img src={r.teamLogo} alt="" className="w-5 h-5 object-contain" />}{r.team}</div></td>
                <td className="p-3 text-right text-white font-extrabold text-base">{r.goals}</td>
                {extra && <><td className="p-3 text-right text-slate-200 hidden sm:table-cell">{r.assists}</td>
                <td className="p-3 text-right text-slate-400 hidden md:table-cell">{r.apps}</td></>}
              </tr>))}</tbody>
          </table>
        </div>)}
      {d?.season && <p className="text-[11px] text-slate-500 mt-2">Season {d.season}/{String(d.season + 1).slice(2)}</p>}
    </div>
  );
};
